/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Weekdays_PickInputs */

const en_us2_onboarding_weekdays_pick = /** @type {(inputs: Onboarding_Weekdays_PickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick at least one day.`)
};

const pt_br2_onboarding_weekdays_pick = /** @type {(inputs: Onboarding_Weekdays_PickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marque pelo menos um dia.`)
};

const es_419_onboarding_weekdays_pick = /** @type {(inputs: Onboarding_Weekdays_PickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marca al menos un día.`)
};

const pt_pt2_onboarding_weekdays_pick = /** @type {(inputs: Onboarding_Weekdays_PickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marca pelo menos um dia.`)
};

const fr_fr2_onboarding_weekdays_pick = /** @type {(inputs: Onboarding_Weekdays_PickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choisis au moins un jour.`)
};

const de_de2_onboarding_weekdays_pick = /** @type {(inputs: Onboarding_Weekdays_PickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wähle mindestens einen Tag.`)
};

const it_it2_onboarding_weekdays_pick = /** @type {(inputs: Onboarding_Weekdays_PickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scegli almeno un giorno.`)
};

/**
* | output |
* | --- |
* | "Pick at least one day." |
*
* @param {Onboarding_Weekdays_PickInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_weekdays_pick = /** @type {((inputs?: Onboarding_Weekdays_PickInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Weekdays_PickInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_weekdays_pick(inputs)
	if (locale === "es-419") return es_419_onboarding_weekdays_pick(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_weekdays_pick(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_weekdays_pick(inputs)
	if (locale === "de-DE") return de_de2_onboarding_weekdays_pick(inputs)
	if (locale === "it-IT") return it_it2_onboarding_weekdays_pick(inputs)
	return en_us2_onboarding_weekdays_pick(inputs)
});
export { onboarding_weekdays_pick as "onboarding.weekdays_pick" }